import type { ManagedMcpIntegration } from '../../../../services/mcpService';
import type { McpProviderUiModule } from './types';

const isGoogleCalendarIntegration = (integration: ManagedMcpIntegration) => {
  const code = (integration.code || '').toLowerCase();
  const name = (integration.name || '').toLowerCase();
  const description = (integration.description || '').toLowerCase();
  return (
    code.includes('google-calendar') ||
    code.includes('google_calendar') ||
    name.includes('google calendar') ||
    description.includes('google calendar')
  );
};

export const googleCalendarProviderUiModule: McpProviderUiModule = {
  providerCode: 'google-calendar',
  matches: (integration: ManagedMcpIntegration) => isGoogleCalendarIntegration(integration),
  getUiConfig: () => ({
    providerCode: 'google-calendar',
    displayName: 'Google Calendar',
    supportsDynamicClientRegistration: false,
    requireClientId: true,
    requireClientSecret: true,
    showEndpointOverride: false,
    oauthClientIdLabel: 'Google OAuth Client ID',
    oauthClientSecretLabel: 'Google OAuth Client Secret',
  }),
};
